import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import VueLazyload from 'vue-lazyload';
import qs from 'qs'

import 'animate.css'
import { WOW } from 'wowjs';
new WOW({live:false}).init();


import AOS from "aos";
import "../node_modules/aos/dist/aos.css";
Vue.use(AOS)
AOS.init();

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'vMTFskp014SXpezrCMUezEDrCyqb1cti'
})



Vue.use(VueAwesomeSwiper);
Vue.use(VueLazyload,{
  preLoad: 1.3,
  loading: require('./resource/loading.png'),
  attempt: 1
});

router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js